module.exports = __webpack_public_path__ + "img/36.060647c4.png";